<template>
  <home />
</template>
<script>
import home from '@telexpress_auth/vue-cloudshop/dist/components/cloudshopsharing.umd.min';
import '@telexpress_auth/vue-cloudshop/dist/components/cloudshopsharing.css';

export default {
  components: {
    home
  },
  data() {
    return {
      leavepopup: true
    };
  },
  created() {
    this.leavepopup = true;
  },
  beforeRouteLeave: home.beforeRouteLeave,
};
</script>
